export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.58594 17.9468L20.5859 17.9468L20.5859 19.9468L3.58594 19.9468L3.58594 17.9468Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 12L8 19L6 19L6 12L8 12Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 9L13 19L11 19L11 9L13 9Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 4L18 19L16 19L16 4L18 4Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);
